import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import { Form, Field } from 'react-final-form';
import FormTextField from '../../form/FormTextField';
import { signInFormValidation } from '../../../models/auth/AuthModelValidation';

const SignInForm = ({ onSubmit }) => {
  return (
    <Form
      onSubmit={onSubmit}
      validate={signInFormValidation}
      render={({ handleSubmit, submitting }) => (
        <form onSubmit={handleSubmit}>
          <div>
            <Field
              name="email"
              type="email"
              component={FormTextField}
              label="Email"
              fullWidth
              autoFocus
            />
          </div>
          <div>
            <Field
              name="password"
              type="password"
              component={FormTextField}
              label="Hasło"
              fullWidth
            />
          </div>
          
          <div style={{ marginTop: 16 }}>
            <Button variant="contained" color="primary" type="submit" disabled={submitting}>
              {submitting ? 'Logowanie...' : 'Zaloguj'}
            </Button>
          </div>
        </form>
      )}
    />
  );
};

SignInForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
};

export default SignInForm;



// WEBPACK FOOTER //
// ./src/components/auth/signIn/SignInForm.js